import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import { getIsDesktop } from '../../../utils/Utils';
import BaseDesktopDialog from '../../../custom_views/BaseDesktopDialog';
import AdvantagesSlider from './AdvantagesSlider';

function ExpertsAdvantagesDialog(props) {
    const isShow = props.isShow
    const setShow = props.setShow
    const close = () => {
       setShow(false)
    }
    const isDesktop = getIsDesktop()
    
    const getInnerHtml = () =>{
        return(
            <div style={isDesktop ? {maxWidth : '360px'} : {}} className="call_info_container">
                <AdvantagesSlider pickedAdvantage={props.pickedAdvantage} advantages={props.advantages}/>
            </div>
        )
    }
    if (isDesktop){
        if (!isShow){
            return(<div/>)
        } 
        return(<BaseDesktopDialog isShow={isShow} setShow={close} getInnerHtml={getInnerHtml}/>)
    } else {
        return (
            <BottomSheet style={{zIndex : 9999}} open={isShow} onDismiss={close}>
                {getInnerHtml()}
            </BottomSheet>
        )
    }
}

export default ExpertsAdvantagesDialog;


